namespace TR {
    class HolidayDealListing {
        hotel: any;
        openImageGallery: any;
        openGallery: any;
        searchId: string;
        eagerLoadImage: boolean;
        duration: number;
        dealPriceFormat: string;

        constructor (
            private dateUtil: any,
            private reviewService: any,
            private pagingService: Core.PagingService,
            private broker: Core.Broker,
            private $scope: any,
            private filtering: Filtering,
            holidayDeals: any
        ) { }

        showDeals(deals) {
            this.broker.publish('SHOWDEALS', { hotel: this.hotel });
        }

        getFirstDate(deals) {
            return (deals && deals[0] && deals[0].HotelDeal) ?
                this.dateUtil.parseDate(deals[0].HotelDeal.CheckInDate) : '';
        }
    }

    angular
        .module('TR')
        .directive('holidayDealListing', (): ng.IDirective => {
            return {
                scope: {},
                templateUrl: (element, attrs) =>
                    'partials/home/directivetemplate?type=' + (attrs.templateOverride || 'HolidayDealListing'),
                replace: true,
                bindToController: {
                    hotel: '=',
                    priceMode: '=',
                    eagerLoadImage: '=',
                    duration: '=',
                    discountPercentage: '=',
                    dealPriceFormat: '='
                },
                controller: HolidayDealListing,
                controllerAs: 'hl'
            };
        });

}
